import _path from "path";
import _module from "module";
import _fs from "fs";
var exports = {};
const path = _path;
const Module = _module;
const fs = _fs;

const resolveFrom = (fromDirectory, moduleId, silent) => {
  if (typeof fromDirectory !== "string") {
    throw new TypeError(`Expected \`fromDir\` to be of type \`string\`, got \`${typeof fromDirectory}\``);
  }

  if (typeof moduleId !== "string") {
    throw new TypeError(`Expected \`moduleId\` to be of type \`string\`, got \`${typeof moduleId}\``);
  }

  try {
    fromDirectory = fs.realpathSync(fromDirectory);
  } catch (error) {
    if (error.code === "ENOENT") {
      fromDirectory = path.resolve(fromDirectory);
    } else if (silent) {
      return;
    } else {
      throw error;
    }
  }

  const fromFile = path.join(fromDirectory, "noop.js");

  const resolveFileName = () => Module._resolveFilename(moduleId, {
    id: fromFile,
    filename: fromFile,
    paths: Module._nodeModulePaths(fromDirectory)
  });

  if (silent) {
    try {
      return resolveFileName();
    } catch (error) {
      return;
    }
  }

  return resolveFileName();
};

exports = (fromDirectory, moduleId) => resolveFrom(fromDirectory, moduleId);

exports.silent = (fromDirectory, moduleId) => resolveFrom(fromDirectory, moduleId, true);

export default exports;
export const silent = exports.silent;